exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".complex-link{text-decoration:none!important}.complex-link:hover .underline-hover{text-decoration:underline!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-summary-table/reservation-summary-table.css"],"names":[],"mappings":"AAAA,cACE,8BAAiC,CAClC,qCAGC,mCAAsC,CACvC","file":"reservation-summary-table.css","sourcesContent":[".complex-link {\n  text-decoration: none !important;\n}\n\n.complex-link:hover .underline-hover {\n  text-decoration: underline !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-summary-table/reservation-summary-table.css
// module id = oYWb
// module chunks = 0